import type { DayHours } from "../api/types";
import { t } from "../i18n";
import { readTime } from "../lib/time";
import { useToast } from "./toasts";
import { SaveInput } from "./SaveInput";

interface Props {
  /** Monday first; null = closed that day. */
  hours: DayHours[];
  /** The hours a closed day gets when it opens again. */
  reopen: [string, string];
  disabled?: boolean;
  onChange: (hours: DayHours[]) => void;
}

/**
 * Hours per day as in the prototype (delivery hours, opening hours): "van – tot" and "gesloten". A
 * time may be typed as 17, 17.00 or 17h00; anything else is refused with a message.
 */
export function HoursTable({ hours, reopen, disabled, onChange }: Props) {
  const toast = useToast();
  const text = t.hours;
  const set = (day: number, value: DayHours) => {
    onChange(hours.map((current, index) => (index === day ? value : current)));
  };
  return (
    <table className="hours">
      <tbody>
        {text.days.map((day, index) => {
          const today = hours[index] ?? null;
          const time = (which: 0 | 1) => (
            <SaveInput
              value={today ? today[which] : ""}
              label={which === 0 ? text.from(day) : text.to(day)}
              placeholder={text.placeholder}
              className="num tm"
              inputMode="decimal"
              maxLength={5}
              disabled={today === null || disabled === true}
              onSave={(value) => {
                if (!today) return;
                const read = readTime(value);
                if (read === null) {
                  toast(text.badTime, "bad");
                  return;
                }
                set(index, which === 0 ? [read, today[1]] : [today[0], read]);
              }}
            />
          );
          return (
            <tr key={day}>
              <td>{day}</td>
              <td>
                {time(0)} – {time(1)}
              </td>
              <td>
                <label className="inl">
                  <input
                    type="checkbox"
                    checked={today === null}
                    disabled={disabled}
                    onChange={(event) => {
                      set(index, event.target.checked ? null : reopen);
                    }}
                  />{" "}
                  {text.closed}
                </label>
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
